import signUpFlowAnimation from "../../../../contents/images/tutorials/supabase-nextjs-signup-funnel/supabase-signup-flow.gif";
import * as React from 'react';
export default {
  signUpFlowAnimation,
  React
};